import filterSchema from './filterSchema';

const schema = (props: any): any => {
    let _schema: any = {
        tabs: {
            type: 'array',
            title: 'Add tabs',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string', title: 'Enter tab id' },
                    name: { type: 'string', title: 'Enter tab name' },
                    downloadTabName: { type: 'string', title: 'Enter download tab name' },
                    tabColumns: { type: 'string', title: 'Tab columns' },
                    haveDiffDownloadColumns: {
                        type: 'boolean',
                        title: 'Have different download columns',
                        description:
                            'If checked, you can set different download columns for this tab',
                    },
                    isDefaultSelected: { type: 'boolean', title: 'Is tab default selected' },
                    footerText: { type: 'string', title: 'Footer text' },
                    headerText: { type: 'string', title: 'Header text' },
                    hideColumnVisibilityToggle: {
                        type: 'boolean',
                        title: 'Hide column visibility toggle',
                        default: false,
                    },
                    hasTabFilter: {
                        type: 'boolean',
                        title: 'Has separate filters for this tab?',
                        default: false,
                    },
                    tabParamValue: {
                        type: 'string',
                        title: 'Tab param value',
                    },
                    useTransformFunction: {
                        type: 'boolean',
                        title: 'Transform function',
                        description: 'Function to transform tab data',
                    },
                },
                dependencies: {
                    haveDiffDownloadColumns: {
                        oneOf: [
                            {
                                properties: {
                                    haveDiffDownloadColumns: { enum: [true] },
                                    downloadColumns: {
                                        type: 'string',
                                        title: 'Download Tab columns',
                                    },
                                },
                            },
                            {
                                properties: {
                                    haveDiffDownloadColumns: { enum: [false] },
                                },
                            },
                        ],
                    },
                    useTransformFunction: {
                        oneOf: [
                            {
                                properties: {
                                    useTransformFunction: { enum: [true] },
                                    functionToTransform: {
                                        type: 'string',
                                        title: 'Function to transform',
                                        default:
                                            // eslint-disable-next-line max-len
                                            'return (data) => {\n   const rowsData = data.rowsData;\n   return { rowsData }\n}',
                                    },
                                },
                            },
                            {
                                properties: {
                                    useTransformFunction: { enum: [false] },
                                },
                            },
                        ],
                    },
                    hasTabFilter: {
                        oneOf: [
                            {
                                properties: {
                                    hasTabFilter: { enum: [true] },
                                    ...filterSchema.schema(props),
                                },
                            },
                            {
                                properties: {
                                    hasTabFilter: { enum: [false] },
                                },
                            },
                        ],
                    },
                },
            },
        },
        tabUrlParam: { type: 'string', title: 'Url param for tab' },
        isTabsSticky: {
            type: 'boolean',
            title: 'Is sticky to page',
        },
    };

    if (props.tabs?.length > 1) {
        _schema = {
            ..._schema,
            hideTabs: {
                type: 'boolean',
                title: 'Hide tab header',
                description: 'for ex- if there is only one tab hide tabs section',
                value: false,
            },
        };
    }

    return _schema;
};

const uiSchema = {
    tabs: {
        items: {
            'ui:field': 'CollapsibleFieldTemplate',
            'ui:order': [
                'id',
                'name',
                'downloadTabName',
                'tabColumns',
                'haveDiffDownloadColumns',
                'downloadColumns',
                'isDefaultSelected',
                'footerText',
                'headerText',
                'hideColumnVisibilityToggle',
                'useTransformFunction',
                'functionToTransform',
                'hasTabFilter',
                'tabParamValue',
                '*',
            ],
            id: { 'ui:widget': 'CustomTextInput' },
            name: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            downloadTabName: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            tabColumns: {
                'ui:widget': 'FormDataMultiSelect',
                customProps: { dataKey: 'columns.id' },
            },
            haveDiffDownloadColumns: { 'ui:widget': 'CustomCheckbox' },
            downloadColumns: {
                'ui:widget': 'FormDataMultiSelect',
                customProps: { dataKey: 'columns.id' },
            },
            isDefaultSelected: { 'ui:widget': 'CustomCheckbox' },
            footerText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            headerText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            hideColumnVisibilityToggle: { 'ui:widget': 'CustomCheckbox' },
            hasTabFilter: { 'ui:widget': 'CustomCheckbox' },
            tabParamValue: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            ...filterSchema.uiSchema,
            useTransformFunction: { 'ui:widget': 'CustomCheckbox' },
            functionToTransform: { 'ui:widget': 'JSEditor' },
        },
    },
    tabUrlParam: { 'ui:widget': 'CustomTextInput' },
    hideTabs: { 'ui:widget': 'CustomCheckbox' },
    isTabsSticky: { 'ui:widget': 'CustomCheckbox' },
};

const tabSchema = {
    schema,
    uiSchema,
};

export default tabSchema;
